import { linkApple, linkGoogle, useAppDispatch } from "@lib/stores";
import { AuthActions } from "@lib/stores/auth/slices";
import { TokenResponse } from "@react-oauth/google";
import { useEffect, useState } from "react";

interface AppleLoginResponse {
  authorization: {
    code: string;
    id_token: string;
  };
}

export const useLinkedAccounts = () => {
  const dispatch = useAppDispatch();
  const [isApplePopup, setIsApplePopup] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsApplePopup(true), 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const onGoogleSubmit = (response: TokenResponse) => {
    if (response !== null && response !== undefined && response.access_token) {
      const token = response.access_token;

      linkGoogle(
        {
          token,
        },
        () => {
          dispatch(AuthActions.getLinkedAccountsAsync());
        }
      );
    }
  };

  const onAppleSubmit = (response: AppleLoginResponse) => {
    if (response?.authorization?.id_token) {
      const {
        authorization: { id_token },
      } = response;

      linkApple(
        {
          token: id_token,
        },
        () => {
          dispatch(AuthActions.getLinkedAccountsAsync());
        }
      );
    }
  };

  return {
    isApplePopup,
    onAppleSubmit,
    onGoogleSubmit,
  };
};
